import React, { useEffect, useState } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { getStateList } from "../../redux/actions/indexActions";
import { toast } from "react-toastify";

const UpdateDestinationDetails = () => {
    const { id } = useParams();
    const [formData, setFormData] = useState({
        state_id: "",
        city_id: 0,
        town_id: 0,
    });
    const [cities, setCities] = useState([]);
    const [towns, setTowns] = useState([]);
    const {
        AuthReducer: { auth },
        indexReducer: { stateLists }
    } = useSelector((state) => state);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getStateList(auth.token));
    }, [auth]);

    useEffect(() => {
        if (formData.state_id) {
            setFormData((prev) => ({ ...prev }));
            axios(`/api/admin/v1/get-city/${formData.state_id}`)
                .then(({ data }) => {
                    setCities(data?.data);
                }).catch((err) => console.error(err));
        } else {
            setCities([]);
        }
    }, [formData.state_id]);

    useEffect(() => {
        if (formData.state_id && formData.city_id) {
            axios(`/api/admin/v1/get-town/${formData.state_id}/${formData.city_id}`)
                .then(({ data }) => {
                    setTowns(data?.data);
                }).catch((err) => console.error(err));
        } else {
            setTowns([]);
        }
    }, [formData?.state_id, formData?.city_id]);
    const handleSubmit = () => {
        const form = new FormData();
        form.append('state_id', formData.state_id)
        form.append('city_id', formData.city_id)
        form.append('town_id', formData.town_id)
        axios.put(`/api/admin/v1/update-destination/${id}`, form, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message);
            navigate(-1);
        }).catch((err) => {
            toast.error(err.response.data);
        });
    };
    useEffect(() => {
        axios(`/api/admin/v1/edit-destination-details/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {

            setFormData({
                state_id: res.data?.destination?.state_id,
                city_id: res.data?.destination?.city_id,
                town_id: res.data?.destination?.town_id,
            });
        }).catch((err) => console.log(err));
    }, [auth]);

    return (
        <div>
            <div className="row my-3">
                <div className="col-md-10">
                    <h4 className="text-white">Edit Destination</h4>
                </div>
            </div>
            <div className="bg-white px-3 py-4 rounded-2  my-4">

                <div className="row">
                    <div className="col-md-6 offset-md-3">
                        <FormGroup>
                            <Label for="state_id">State</Label>
                            <Input type="select" name="state_id" id="state_id" value={formData.state_id} onChange={(e) => setFormData({ ...formData, state_id: e.target.value })}>
                                <option value="">Select State</option>
                                {stateLists?.map((state) => (
                                    <option key={state.id} value={state.id}>{state.state_name}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    </div>
                    <div className="col-md-6 offset-md-3">
                        <FormGroup>
                            <Label for="city_id">City</Label>
                            <Input type="select" name="city_id" id="city_id" value={formData.city_id} onChange={(e) => setFormData({ ...formData, city_id: e.target.value })}>
                                <option value="">Select City</option>
                                {cities?.map((city) => (
                                    <option key={city.id} value={city.id}>{city.city_name}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    </div>
                    <div className="col-md-6 offset-md-3">
                        <FormGroup>
                            <Label for="town_id">Town</Label>
                            <Input type="select" name="town_id" id="town_id" value={formData.town_id} onChange={(e) => setFormData({ ...formData, town_id: e.target.value })}>
                                <option value="">Select Town</option>
                                {towns?.map((town) => (
                                    <option key={town.id} value={town.id}>{town.town_name}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    </div>
                    <div className="col-md-12 text-center">
                        <Button color="primary" onClick={handleSubmit}>
                            Update
                        </Button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default UpdateDestinationDetails;
